module.exports = __webpack_public_path__ + "img/actions.ad418344.svg";